import dayjs from "dayjs";

type AppointmentRequestLike =
  | {
      available_day_set?: string[];
      day_set?: Array<{ start?: unknown }>;
    }
  | null
  | undefined;

export function formatAppointmentRequestAvailableDaysText(
  item: AppointmentRequestLike,
): string | null {
  const availableDays = item?.available_day_set;
  if (!availableDays || availableDays.length === 0) {
    return null;
  }

  const sortedDays = [...availableDays].sort((a, b) => dayjs(a).diff(dayjs(b)));
  const firstDay = sortedDays[0];
  const lastDay = sortedDays[sortedDays.length - 1];

  if (firstDay === lastDay) {
    return dayjs(firstDay).format("DD.MM.YYYY");
  }

  return `${dayjs(firstDay).format("DD.MM.YYYY")} – ${dayjs(lastDay).format(
    "DD.MM.YYYY",
  )}`;
}
